const openGuestChatButton = document.getElementById("openGuestChat") as HTMLButtonElement;
const openAuthChatButton = document.getElementById("openAuthChat") as HTMLButtonElement;

openGuestChatButton.onclick = function () {
	window.open("/cba?auth=false", "_blank", "noopener,noreferrer");
};

openAuthChatButton.onclick = function () {
	window.open("/cba?auth=true", "_blank", "noopener,noreferrer");
};
